import React, { Component } from "react";
import PropTypes from "prop-types";
import OverviewLayoutContainer from "../components/OverviewLayout/container";
import Chapter from "../components/Chapter";
import PreviewList from "../components/PreviewList";
import getOr from "lodash/fp/getOr";

class ChapterTemplate extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const chapter = this.props.data.soetChapterNode;
    const previews = getOr([], "childrenSoetArticleNode", chapter);
    return (
      <OverviewLayoutContainer
        overview={
          <Chapter
            nextPath={chapter.nextPath}
            subTitle={chapter.subTitle}
            text={chapter.text}
            title={chapter.title}
            titleNumber={chapter.titleNumber}
          />
        }
        previews={<PreviewList previews={previews} title="The Research" />}
      />
    );
  }
}

export default ChapterTemplate;

const articlePreviewPropTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
  type: PropTypes.string
};

ChapterTemplate.propTypes = {
  data: PropTypes.shape({
    soetChapterNode: PropTypes.shape({
      articlePreviews: PropTypes.arrayOf(
        PropTypes.shape({
          ...articlePreviewPropTypes
        })
      ),
      subTitle: PropTypes.string,
      title: PropTypes.string,
      text: PropTypes.string
    })
  })
};

/**
 * We want to get:
 *
 * - current chapter
 * - article previews for this chapter
 */
// eslint-disable-next-line no-undef
export const chapterQuery = graphql`
  query ChapterQuery($chapterId: Int!) {
    soetChapterNode(chapterId: { eq: $chapterId }) {
      id
      chapterId
      nextPath
      path
      subTitle
      text
      title
      titleNumber
      childrenSoetArticleNode {
        id
        articleId
        path
        title
        titleNumber
        sortOrder
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/chapter.js